function twitterImageUpdate() {
    const twitterItems = document.querySelectorAll('.single.twitter.no-img');
    if (twitterItems.length > 0) {
        twitterItems.forEach((tile) => {
            tile.classList.add('twitter-default-image');
            tile.classList.remove('no-img');
            const image = `<div class="img visible"><img alt="Axway" src="https://content.cdntwrk.com/files/aHViPTcwMjM0JmNtZD1pdGVtZWRpdG9yaW1hZ2UmZmlsZW5hbWU9aXRlbWVkaXRvcmltYWdlXzYyMTM0ODQ3YjExMGYucG5nJnZlcnNpb249MDAwMCZzaWc9NjY3Y2JiMDg4ZjQzNGVmNGE4OGIwZmUyNTMyMGZiOWI%253D" class="taller"></div>`;
            tile.insertAdjacentHTML('afterbegin', image);
        });
    }
    setTimeout(() => {
        const itemPage = document.querySelector('.single-page.twitter');
        if (itemPage) {
            const target = document.querySelector('.entry');
            if (target) {
                const checkImg = target.querySelector('img');
                const image = `<img class="large" alt="Axway" src="https://content.cdntwrk.com/files/aHViPTcwMjM0JmNtZD1pdGVtZWRpdG9yaW1hZ2UmZmlsZW5hbWU9aXRlbWVkaXRvcmltYWdlXzYyMTM0ODQ3YjExMGYucG5nJnZlcnNpb249MDAwMCZzaWc9NjY3Y2JiMDg4ZjQzNGVmNGE4OGIwZmUyNTMyMGZiOWI%253D" />`;
                if (!checkImg) {
                    target.insertAdjacentHTML('afterbegin', image);
                }
            }
        }
    }, 500);

}

export { twitterImageUpdate };


// WEBPACK FOOTER //
// ./scriptPartials/twitterTiles.js